// extracted by mini-css-extract-plugin
export default {"item":"search-list-item_item__K-Tl5"};